var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "countdown" }, [
    _c("p", [_vm._v(_vm._s(_vm.$t("general.timeToRefresh")))]),
    _c("p", { staticClass: "timer" }, [_vm._v(_vm._s(_vm.refreshTime))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }